import React from 'react'
import Header from '../Header';
import Sidebar from '../Sidebar';
const ShippingOrders = () => {
  return (
    <>
      <Header/>
     <Sidebar/>
      <main className="main" id="main">
        <div className="container">
          <section className="section">
            <div className="row">
              <div className="col-lg-12">
              <div class="card">
            <div class="card-body">
              <h5 class="card-title">Default Table</h5>

              {/* <!-- Default Table --> */}
              <table class="table">
                <thead>
                  <tr>
                  <th>Order ID</th>
            <th>Recipient Name</th>
            <th>Address</th>
            <th>City</th>
            <th>Postal Code</th>
            <th>Shipping Method</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <th scope="row">1</th>
                    <td>Gulafshan</td>
                    <td>23/A,MFT Road</td>
                    <td>Jaipur</td>
                    <td>28</td>
                    <td>Home Delivery</td>
                  </tr>
                  <tr>
                    <th scope="row">2</th>
                    <td>Bridie Kessler</td>
                    <td>Developer</td>
                    <td>35</td>
                    <td>2014-12-05</td>
                  </tr>
                  <tr>
                    <th scope="row">3</th>
                    <td>Ashleigh Langosh</td>
                    <td>Finance</td>
                    <td>45</td>
                    <td>2011-08-12</td>
                  </tr>
                  <tr>
                    <th scope="row">4</th>
                    <td>Angus Grady</td>
                    <td>HR</td>
                    <td>34</td>
                    <td>2012-06-11</td>
                  </tr>
                  <tr>
                    <th scope="row">5</th>
                    <td>Raheem Lehner</td>
                    <td>Dynamic Division Officer</td>
                    <td>47</td>
                    <td>2011-04-19</td>
                  </tr>
                </tbody>
              </table>
              {/* <!-- End Default Table Example --> */}
            </div>
          </div>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  )
}

export default ShippingOrders